import React, { useState, useEffect } from "react";
import ActivityCard from "./ActivityCard";
import { AlertCircle, Inbox } from "lucide-react";

const ActivityList = ({
  activities = [],
  loading = false,
  error = null,
  selectedActivities = [],
  onSelectToggle,
  onReaction,
  onGradeClick,
  onImageClick,
  onDocView,
  processing = false,
  currentUserEmail,
  fromSource = "Professor",
}) => {
  const [expandedActivityId, setExpandedActivityId] = useState(null);

  useEffect(() => {
    setExpandedActivityId(null);
  }, [activities]);

  if (loading) {
    return (
      <div className="py-12 flex flex-col items-center justify-center text-slate-400">
        <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mb-3"></div>
        <p className="text-xs font-medium">Loading student activities...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 rounded-xl bg-rose-50 border border-rose-200 text-rose-800 text-xs flex items-center gap-2">
        <AlertCircle className="w-4 h-4 flex-shrink-0 text-rose-600" />
        <span>{error}</span>
      </div>
    );
  }

  if (activities.length === 0) {
    return (
      <div className="py-12 flex flex-col items-center justify-center text-slate-400 border-2 border-dashed border-slate-200 rounded-2xl bg-slate-50/50">
        <Inbox className="w-10 h-10 mb-2 stroke-[1.5]" />
        <p className="text-sm font-semibold text-slate-700">No activities found</p>
        <p className="text-xs text-slate-500 mt-1">
          This student has not logged any activities matching the filter criteria.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {activities.map((act) => (
        <ActivityCard
          key={act.id}
          activity={act}
          isSelected={selectedActivities.includes(act.id)}
          isExpanded={expandedActivityId === act.id}
          onExpandToggle={() => setExpandedActivityId((prev) => (prev === act.id ? null : act.id))}
          onSelectToggle={onSelectToggle}
          onReaction={onReaction}
          onGradeClick={onGradeClick}
          onImageClick={onImageClick}
          onDocView={onDocView}
          processing={processing}
          currentUserEmail={currentUserEmail}
          fromSource={fromSource}
        />
      ))}
    </div>
  );
};

export default ActivityList;
